var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTablet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 21C12.7348 21 12.4804 21.1054 12.2929 21.2929C12.1054 21.4804 12 21.7348 12 22C12 22.2652 12.1054 22.5196 12.2929 22.7071C12.4804 22.8946 12.7348 23 13 23H19C19.2652 23 19.5196 22.8946 19.7071 22.7071C19.8946 22.5196 20 22.2652 20 22C20 21.7348 19.8946 21.4804 19.7071 21.2929C19.5196 21.1054 19.2652 21 19 21H13ZM5.25 5C4.38805 5 3.5614 5.34241 2.9519 5.9519C2.34241 6.5614 2 7.38805 2 8.25V23.75C2 24.612 2.34241 25.4386 2.9519 26.0481C3.5614 26.6576 4.38805 27 5.25 27H26.75C27.612 27 28.4386 26.6576 29.0481 26.0481C29.6576 25.4386 30 24.612 30 23.75V8.25C30 7.38805 29.6576 6.5614 29.0481 5.9519C28.4386 5.34241 27.612 5 26.75 5H5.25ZM4 8.25C4 7.56 4.56 7 5.25 7H26.75C27.44 7 28 7.56 28 8.25V23.75C28 24.44 27.44 25 26.75 25H5.25C4.56 25 4 24.44 4 23.75V8.25Z",
    className: "svgFill"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTablet);
export default __webpack_public_path__ + "static/media/tablet.ad9f0198024f3b31c52138b7dc838b5d.svg";
export { ForwardRef as ReactComponent };